import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=04c2f148&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c2f148')) {
      api.createRecord('04c2f148', component.options)
    } else {
      api.reload('04c2f148', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=04c2f148&", function () {
      api.rerender('04c2f148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MainMenu.vue"
export default component.exports